import React, { PropTypes } from 'react';
import { contentTypes } from '../../langMap';

const Thankyou = (props) => {
  const { data, lang } = props;
  if (data.length === 0) {
    return null;
  }
  return (
    <section className="subsection subsection-thankyou">
      <header className="subsection__header">
        {
          lang === 'ar' ?
            <h2 className="subsection__header__title">{contentTypes.thankyou}</h2> :
            <h2 className="subsection__header__title">Thank you</h2>
        }
      </header>
      <ul className="slash-separated__list thankyou-list">
        { data.map((item, index) =>
          <li
            className="slash-separated__list__item thankyou-list__item"
            key={item.id}
          >{item.name}{ index === data.length - 1 ? '.' : ' /'}</li>)
        }
      </ul>
    </section>
  );
};

export default Thankyou;

Thankyou.propTypes = {
  lang: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
};



// WEBPACK FOOTER //
// ./js/components/support/Thankyou.js